const hasInvoice = state => state.hasInvoice
const downloadSimple = state => state.download.simpleExcel
const downloadDetail = state => state.download.detailCSV
const downloadInvoice = state => state.download.invoicePDF
const invoiceMonths = state => state.invoiceMonths
const summaryStatistics = state => state.summaryStatistics
const summaryMonths = state => state.summaryMonths
const summaryRegions = state => state.summaryRegions
const summaryWeeks = state => state.summaryWeeks
const summaryDates = state => state.summaryDates
const summaryProducts = state => state.summaryProducts
const compareEstimated = state => state.compareEstimated
const comparePrevMonth = state => state.comparePrevMonth
const totalCost = state => state.totalCost
const detail = state => state.detail
const cost = state => state.cost
const widgetCardModel = state => state.widget.cardModel
const customDashboard = state => state.customDashboard
const customDashboardIdx = state => state.customDashboardIdx
const editDashboard = state => state.editDashboard

const hasInvoiceStatus = state => state.status.hasInvoice
const downloadSimpleStatus = state => state.status.download.simpleExcel
const downloadDetailStatus = state => state.status.download.detailCSV
const downloadInvoiceStatus = state => state.status.download.invoicePDF
const invoiceMonthsStatus = state => state.status.invoiceMonths
const summaryStatisticsStatus = state => state.status.summaryStatistics
const summaryMonthsStatus = state => state.status.summaryMonths
const summaryRegionsStatus = state => state.status.summaryRegions
const summaryWeeksStatus = state => state.status.summaryWeeks
const summaryDatesStatus = state => state.status.summaryDates
const summaryProductsStatus = state => state.status.summaryProducts
const compareEstimatedStatus = state => state.status.compareEstimated
const comparePrevMonthStatus = state => state.status.comparePrevMonth
const totalCostStatus = state => state.status.totalCost
const detailStatus = state => state.status.detail
const costStatus = state => state.status.cost
const loadingStatus = state => {
    let flag = false
    for (let key in state.status) {
        if (state.status[key] === 'loading') {
            flag = true
            break
        }
    }
    return flag
}
const getCustomDashboardStatus = state => state.status.getCustomDashboard
const saveCustomDashboardStatus = state => state.status.saveCustomDashboard
const currentParams = state => state.currentParams

export default {
    hasInvoice,
    downloadSimple,
    downloadDetail,
    downloadInvoice,
    invoiceMonths,
    summaryStatistics,
    summaryMonths,
    summaryRegions,
    summaryWeeks,
    summaryDates,
    summaryProducts,
    compareEstimated,
    comparePrevMonth,
    totalCost,
    detail,
    cost,
    widgetCardModel,
    customDashboard,
    customDashboardIdx,
    editDashboard,
    hasInvoiceStatus,
    downloadSimpleStatus,
    downloadDetailStatus,
    downloadInvoiceStatus,
    invoiceMonthsStatus,
    summaryStatisticsStatus,
    summaryMonthsStatus,
    summaryRegionsStatus,
    summaryWeeksStatus,
    summaryDatesStatus,
    summaryProductsStatus,
    compareEstimatedStatus,
    comparePrevMonthStatus,
    totalCostStatus,
    detailStatus,
    costStatus,
    loadingStatus,
    getCustomDashboardStatus,
    saveCustomDashboardStatus,
    currentParams
}
